import React, { useEffect } from 'react';

import { useMutation } from '@apollo/react-hooks';
import { CircularProgress } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

import SOCIAL_AUTH from '../../api/graphql/mutations/user/SOCIAL_AUTH';
import OAUTH_PROVIDERS from '../../constants/dictionaries/oauthProviders';
import messages from '../../constants/dictionaries/messages';
import PATHS from '../../constants/paths';
import { useAuthContext } from '../../context/AuthContext';
import { useUserLogContext } from '../../context/UserLogContext/UserLogContext';
import useCommitError from '../../services/common/useCommitError/useCommitError';
import useSafeMutation from '../../services/common/useSafeMutation/useSafeMutation';

const GoogleLoginCallback = () => {
  const { logEvent } = useUserLogContext();
  const [loginSocialMutation] = useMutation(SOCIAL_AUTH);
  // @ts-ignore
  const { onLogin } = useAuthContext();
  const commitError = useCommitError();
  const safeMutation = useSafeMutation();
  const navigate = useNavigate();

  const handleRoute = async () => {
    const { hash } = window.location;
    if (hash) {
      const params = new URLSearchParams(hash.substring(1));

      const accessToken = params.get('access_token');
      const integrityToken = params.get('state')?.split('=')[1].replace('}', '');
      const integrityCheck = !!integrityToken && localStorage.getItem('google_integrity_token') === integrityToken;

      if (!integrityCheck || !accessToken) {
        navigate(PATHS.LOGIN);
        commitError({ message: 'Google login issue', props: window.location }, messages.ERROR.LOGIN(), 'GoogleLoginCallback');
        return;
      }

      const variables = {
        accessToken,
        provider: OAUTH_PROVIDERS.GOOGLE,
      };

      // @ts-ignore
      const { data } = await safeMutation(
        () => loginSocialMutation({ variables }),
        'Nie udało się zalogować przy pomocy konta Google. Spróbuj za pomocą email.',
      );
      if (data?.socialAuth?.token) {
        logEvent('login-google');
        onLogin(data.socialAuth.token);
      } else {
        navigate(PATHS.LOGIN);
        commitError({ message: 'Google login sync issue', props: window.location }, messages.ERROR.LOGIN(), 'GoogleLoginCallback');
      }
    } else {
      navigate(PATHS.LOGIN);
      commitError({ message: 'Google login issue', props: window.location }, messages.ERROR.LOGIN(), 'GoogleLoginCallback');
    }
  };

  useEffect(() => {
    handleRoute();
  }, []);

  return <CircularProgress size={60} />;
};

export default GoogleLoginCallback;
